<template>
  <v-main>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card :ripple="false" :img="ImgCover" height="240px" width="100%">
    </v-card>
    <v-card
      class="pa-3 pb-10 mt-n10"
      :color="DarkModeBackground"
      v-if="shop.length > 0"
      :style="
        'background-color:' +
          DarkModeBackground +
          ';min-height: 100vh;border-radius: 45px 45px 0px 0px;'
      "
    >
      <v-row>
        <v-col class="text-center">
          <v-avatar
            v-if="shop.length > 0"
            class="mt-n16 pa-1"
            style=""
            :color="DarkModeBackground"
            size="180"
          >
            <img :src="LoGo" />
          </v-avatar>
        </v-col>
      </v-row>
      <!-- <h3 class="text-center mt-3" :style="'color:' + DarkModefont + ';'">
          {{ languageSelect === 0 ? "โอนเงินมัดจำ" : "Booking deposit" }}
        </h3> -->
      <h5
        class="text-center mt-5"
        :style="'color:' + DarkModefont + ';'"
        v-if="shop.length > 0 && shop[0].showShopName === 'True'"
      >
        {{ shop[0].shopName }}
      </h5>
      <v-card
        v-if="checkStatus === true"
        class="pa-5 mt-5 "
        :style="'border-radius: 15px 15px 15px 15px;'"
      >
        <h6 class="mt-3 mb-6">
          {{
            languageSelect === 0
              ? "กรุณาเลือกรายการที่ยังไม่ได้ชำระค่ามัดจำ"
              : "Please select an item for which the deposit has not yet been paid."
          }}
        </h6>
        <v-select
          v-model="bookNo"
          :item-text="SelectBookingData.text"
          :items="SelectBookingData"
          :label="
            languageSelect === 0
              ? 'รายการที่ยังไม่ได้ชำระค่ามัดจำ'
              : 'Item for which the deposit has not yet been paid.'
          "
          @change="getbookingData(), getbooking()"
          attach
          :menu-props="{ bottom: true, offsetY: true }"
          outlined
        ></v-select>
        <!-- <div class="text-center mt-5">
          <v-btn
            class="button"
            :color="DarkModeButton"
            dark
            large
            @click="UploadImg()"
            >{{ languageSelect === 0 ? "ยืนยัน" : "Confirm" }}</v-btn
          >
        </div> -->
      </v-card>
      <v-card
        v-if="BookingData.length > 0"
        class="pa-5 mt-5 "
        :style="'border-radius: 15px 15px 15px 15px;'"
      >
        <v-form ref="uploadForm" v-model="validUploadForm">
          <h4 v-if="!couponStatus" class="text-center font-weight-black mb-10">
            {{
              languageSelect === 0
                ? "แนบหลักฐานการโอนเงิน"
                : "Please attach the transfer file"
            }}
          </h4>
          <h4 v-if="couponStatus" class="text-center font-weight-black mb-10">
            {{
              languageSelect === 0
                ? "แนบภาพคูปองหรือส่วนลด"
                : "Please attach coupon or discount file"
            }}
          </h4>

          <div v-for="(item, key) in BookingData" :key="key">
            <v-row>
              <v-col cols="6" class="py-0">
                <p class="font-weight-black">
                  {{ languageSelect === 0 ? item.fieldName : item.fieldNameEn }}
                </p>
              </v-col>
              <v-col cols="6" class="py-0">
                <p
                  class="font-weight-black"
                  v-if="item.fieldType === 'Checkbox'"
                >
                  {{ (item.fieldValue && item.fieldValue !== '') ? (Array.isArray(JSON.parse(item.fieldValue)) ? JSON.parse(item.fieldValue).join(",") : items.fieldValue) : '' }}
                </p>
                <p class="font-weight-black" v-else>{{ item.fieldValue }}</p>
              </v-col>
            </v-row>
            <!-- <v-text-field
            v-model="item.fieldValue"
            :label="item.fieldName"
            disabled
            outlined
            :background-color="DarkMode"
          ></v-text-field> -->
          </div>
          <v-divider class="mb-6"></v-divider>
          <div
            v-if="shopId === 'U310b4c8934a2781f2c8bdfd73e8f295f'"
            class="p-0"
          >
            <v-row>
              <v-col cols="12" class="py-0">
                <p class="font-weight-black mb-1">
                  {{
                    languageSelect === 0
                      ? joyRideInsuranceDetails
                      : joyRideInsuranceDetailsEn
                  }}
                </p>
              </v-col>
              <v-col cols="12" class="py-0">
                <p class="font-weight-black mb-1">
                  {{
                    languageSelect === 0
                      ? joyRideReserveNowDetails
                      : joyRideReserveNowDetailsEn
                  }}
                </p>
              </v-col>
              <v-col cols="12" class="py-0">
                <p class="font-weight-black mb-1">
                  {{ languageSelect === 0 ? menuItem : menuItemEn }}
                </p>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="12" class="text-center pa-2 mt-6">
              <v-img
                v-if="formUpload.depositImge !== ''"
                class="pa-3"
                contain
                max-height="300"
                max-width="100%"
                :src="formUpload.depositImge"
              ></v-img>
              <v-avatar v-else tile color="#FFFFFF" size="180">
                <v-img
                  v-if="!couponStatus"
                  aspect-ratio="6"
                  contain
                  src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FUploadicon.png?alt=media&token=39383860-d16e-49ca-81cb-a3ad888df095"
                ></v-img>
                <v-img
                  v-if="couponStatus"
                  aspect-ratio="6"
                  contain
                  :src="require('@/assets/coupon.png')"
                ></v-img>
                <!-- <v-img
                aspect-ratio="6"
                contain
                :src="require('@/assets/Uploadicon.png')"
                ></v-img> -->
              </v-avatar>
              <v-file-input
                v-if="!statusSlipOKOpen"
                class="mt-6 mb-6"
                required
                counter
                show-size
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-paperclip"
                label="Upload"
                @change="selectImgCoverUpdate"
                v-model="filesUpdateImgCover"
              ></v-file-input>
              <PaymentUploadSlipOK
                v-else
                @upload-image="handleImageUpload"
                ref="childRef"
              />
            </v-col>
          </v-row>
        </v-form>
        <div class="text-center">
          <v-btn
            class="button"
            :color="DarkModeButton"
            dark
            large
            @click="gotoThank()"
            >{{
              languageSelect === 0 ? "กลับไปหน้าชำระเงิน" : "Back to payment"
            }}
          </v-btn>
          <v-btn
            v-if="!statusSlipOKOpen"
            class="button"
            :color="DarkModeButton"
            dark
            large
            @click="UploadImg()"
            >{{ languageSelect === 0 ? "ยืนยัน" : "Confirm" }}
          </v-btn>
          <v-btn
            v-if="statusSlipOKOpen"
            class="button"
            :color="DarkModeButton"
            dark
            large
            @click="UploadImg"
            >{{ languageSelect === 0 ? "ยืนยัน" : "Confirm" }}
          </v-btn>
          <!-- <PaymentUploadSlipOK v-else ref="childRef"/> -->
        </div>
        <!-- <div class="text-center" v-if="!statusSlipOKOpen && !validUploadForm">
          <p style="color: red;">
            {{
              languageSelect === 0
                ? "ขนาดรูปเกิน กรุณาเปลี่ยนรูปใหม่"
                : "Image too large, please change."
            }}
          </p>
        </div> -->
      </v-card>
    </v-card>
    <GoogleCalendar ref="GoogleCalendarRef" />
  </v-main>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment'
import GoogleCalendar from '../Core/GoogleCalendarCmp.vue'
import PaymentUploadSlipOK from '../Extensions/PaymentUploadSlipOK.vue'
import { getApiErrorMessage, getImageErrorMessage } from '../../utils/apiErrorMessage'
export default {
  components: {
    GoogleCalendar,
    PaymentUploadSlipOK
  },
  data () {
    return {
      overlay: false,
      valid: true,
      validUploadForm: false,
      GroupId: this.$route.query.GroupId,
      bookNo: '',
      userName: '',
      userPassword: '',
      shopId: this.$route.query.shopId,
      profile: null,
      fromAdd: {
        GroupId: '',
        shopId: '',
        bookingStatus: 'N'
      },
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      dialog: false,
      ColorByShop: [],
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '',
      DarkModefont: '',
      shop: [],
      LoGo: [],
      ImgCover: '',
      bookingthankText: null,
      redirectBy: null,
      BookingData: [],
      formUpload: {
        bookNo: '',
        depositImge: '',
        depositStatus: null,
        depositPrice: this.$route.query.depositPrice
      },
      filesUpdateImgCover: null,
      SelectBookingData: [],
      checkStatus: true,
      SelectBooking: '',
      userId: '',
      languageSelect: 0,
      checkStatusBooking: '',
      DataFlowNameAll: [],
      bookingDataSelect: [],
      couponStatus: false,
      statusGoogleCalendar: null,
      statusGoogleCalendarEmp: null,
      joyRideInsuranceDetails: '',
      joyRideInsuranceDetailsEn: '',
      joyRideReserveNowDetails: '',
      joyRideReserveNowDetailsEn: '',
      menuItem: '',
      menuItemEn: '',
      statusSlipOKOpen: false,
      resCheckSlipOK: false
    }
  },
  async mounted () {
    await this.checkbookNo()
    await this.getCheckOpenSlipOK()
    if (this.$route.query.languageSelect) {
      this.languageSelect = parseInt(this.$route.query.languageSelect)
    } else {
      this.languageSelect = 0
    }
    // เลคถ้าเป็น คูปองหรืออื่นๆ
    if (this.$route.query.coupon) {
      this.couponStatus = true
      console.log('คูปองหรืออื่นๆ')
    }
    if (this.shopId === 'U310b4c8934a2781f2c8bdfd73e8f295f') {
      await this.getDetails(this.bookNo)
    }
    // เช็คopen slipOK
    // this.getCheckOpenSlipOK()
  },
  methods: {
    async resizeImageV2 (file, names) {
      if (file) {
        try {
          console.log('เริ่มต้น compress รูปภาพ...')

          // ใช้ Canvas API เพื่อ resize และ compress
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = (event) => {
              const img = new Image()
              img.src = event.target.result
              img.onload = () => {
                const canvas = document.createElement('canvas')
                let width = img.width
                let height = img.height

                // ลดขนาดความกว้าง/สูง ให้เล็กลงเพื่อให้ไฟล์ไม่เกิน 2MB
                const maxDimension = 800 // ลดเหลือ 800px
                if (width > height) {
                  if (width > maxDimension) {
                    height = (height / width) * maxDimension
                    width = maxDimension
                  }
                } else {
                  if (height > maxDimension) {
                    width = (width / height) * maxDimension
                    height = maxDimension
                  }
                }

                canvas.width = width
                canvas.height = height

                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)

                // แปลงเป็น blob ด้วย quality 0.6 (ปรับให้ไม่เกิน 2MB แต่ภาพยังคมพอสมควร)
                canvas.toBlob((blob) => {
                  if (!blob) {
                    reject(new Error('compress image failed'))
                    return
                  }
                  const compressedFile = new File([blob], names, { type: file.type })
                  const compressedImageUrl = URL.createObjectURL(compressedFile)
                  console.log('compress สำเร็จ!')
                  resolve({ 'resizedUrl': compressedImageUrl, 'newFiles': compressedFile })
                }, 'image/jpeg', 0.6)
              }
              img.onerror = reject
            }
            reader.onerror = reject
          })
        } catch (error) {
          this.$swal('คำเตือน', `อัปโหลดรูปภาพเท่านั้น!`, 'warning')
          console.error('Error during image compression', error)
        }
      }
    },
    // callChil
    handleImageUpload (file, image) {
      console.log('file', file)
      console.log('image', image)

      this.formUpload.depositImge = image
      this.filesUpdateImgCover = file
    },
    async getCheckOpenSlipOK () {
      try {
        const resCheckStatusSlipOK = await axios.get(
          `${this.DNS_IP}/master_payment/get?shopId=${this.$route.query.shopId}&switchSlipOK=true&payType=SlipOK`
        )
        if (resCheckStatusSlipOK.data.status !== false) {
          this.statusSlipOKOpen = true
        } else {
          this.statusSlipOKOpen = resCheckStatusSlipOK.data.status
        }
      } catch (error) {
        this.statusSlipOKOpen = false
      }
    },
    gotoThank () {
      let flowId = this.BookingData.filter(
        item => item.bookNo === this.bookNo
      )[0].flowId
      let dt = this.DataFlowNameAll.filter(item => item.flowId === flowId)[0]
      let timeSlotCustomer = 1
      if (dt.customerTimeSlot === 'True') {
        timeSlotCustomer = this.bookingDataSelect[0].timeSlotCustomer || 1
      }
      console.log('dt', dt)
      console.log('timeSlotCustomer', timeSlotCustomer)
      console.log('this.bookingDataSelect', this.bookingDataSelect)
      this.$router.push(
        '/Thank?shopId=' +
          this.shopId +
          '&redirectBy=BookingForm&flowId=' +
          flowId +
          '&bookNo=' +
          this.formUpload.bookNo +
          '&Calculate=' +
          timeSlotCustomer +
          '&languageSelect=' +
          this.languageSelect
      )
    },
    async checkbookNo () {
      this.BookingData = []
      this.SelectBookingData = []
      if (this.$route.query.bookNo) {
        this.bookNo = this.$route.query.bookNo
        this.checkStatus = false
        await this.getShop()
        await this.getbookingData()
        await this.getbooking()
        await this.getDataFlow()
      } else {
        if (
          this.$route.query.error === 'ACCESS_DENIED' ||
          this.$route.query.error === 'access_denied'
        ) {
          this.$swal({
            title: 'ผิดพลาด กรุณากดยอมรับเพื่อ ทำรายการต่อ',
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: 'ยอมรับ',
            cancelButtonText: 'ไม่ยอมรับ'
          })
            .then(async result => {
              this.$router.go()
            })
            .catch(function (error) {
              console.log('Error getting profile: ' + error)
              this.$router.push(
                '/Thank?shopId=' +
                  this.shopId +
                  '&redirectBy=PaymentUpload&languageSelect=' +
                  this.languageSelect
              )
            })
        } else {
          console.log('test')
          let checkShopId = ''
          if (this.$route.query.shopId) {
            checkShopId = this.$route.query.shopId
          } else {
            const queryString = decodeURIComponent(
              window.location.search
            ).replace('?liff.state=', '')
            console.log('queryString', queryString)
            const params = new URLSearchParams(queryString)
            checkShopId = params.get('shopId')
          }
          let dataLineConfig = await this.getDataLineConfig(checkShopId)
          this.shopId = checkShopId
          await this.checkLiffLogin(dataLineConfig)
          await this.getBookingView()
          await this.getShop()
          await this.getDataFlow()
        }
      }
    },
    async getDataFlow () {
      this.DataFlowNameAll = []
      // console.log('DataFlowName', this.DataFlowName)
      let path = ''
      if (this.$route.query.flowId) {
        path =
          '/flow/get?shopId=' +
          this.shopId +
          '&flowId=' +
          this.$route.query.flowId
      } else {
        path = '/flow/get?shopId=' + this.shopId
      }
      await axios.get(this.DNS_IP + path).then(response => {
        let rs = response.data
        console.log('rssssssssssssssFlow', rs)
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            this.DataFlowNameAll.push(d)
          }
        } else {
          this.DataFlowNameAll = []
        }
      })
    },
    async selectImgCoverUpdate () {
      if (this.filesUpdateImgCover) {
        const originalFile = this.filesUpdateImgCover
        const originalSize = originalFile.size
        console.log('ขนาดรูปที่เลือก:', (originalSize / 1024 / 1024).toFixed(2), 'MB')

        // ตรวจสอบขนาดไฟล์ ถ้าเกิน 2MB ให้ resize
        if (originalSize > 2000000) {
          console.log('ขนาดรูปก่อน resize:', (originalSize / 1024 / 1024).toFixed(2), 'MB')
          let resizedData = null
          try {
            resizedData = await this.resizeImageV2(
              originalFile,
              originalFile.name
            )
          } catch (error) {
            console.error('resize image error:', error)
            this.filesUpdateImgCover = null
            this.formUpload.depositImge = ''
            this.$swal(
              this.languageSelect === 0 ? 'รูปภาพไม่ถูกต้อง' : 'Invalid image',
              getImageErrorMessage(this.languageSelect === 0),
              'error'
            )
            return
          }
          if (resizedData) {
            console.log('ขนาดรูปหลัง resize:', (resizedData.newFiles.size / 1024 / 1024).toFixed(2), 'MB')

            // อัพเดทไฟล์ที่จะส่งไป API (ไม่สนใจว่า v-file-input จะแสดงอะไร)
            this.filesUpdateImgCover = resizedData.newFiles
            this.formUpload.depositImge = resizedData.resizedUrl
          }
        } else {
          console.log('ขนาดรูปไม่เกิน 2MB:', (originalSize / 1024 / 1024).toFixed(2), 'MB')
          this.formUpload.depositImge = URL.createObjectURL(
            this.filesUpdateImgCover
          )
        }
      } else {
        this.formUpload.depositImge = ''
      }
    },
    async checkLiffLogin (dataLineConfig) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile()
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getBotinfo () {
      if (this.$route.query.shopId) {
        const url = `${this.DNS_IP}/line/getOa`
        // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
        const config = {
          headers: {
            botId: this.$route.query.shopId
          }
        }
        await axios.get(url, config).then(response => {
          let rs = response.data
          console.log('rs1', rs)
          window.location.href = 'line://ti/p/' + rs.basicId
        })
      }
    },
    async checkBooking (bookNo) {
      await axios
        .get(this.DNS_IP + '/booking_view/get?bookNo=' + bookNo)
        .then(async response => {
          let rs = response.data
          console.log('RSTESTTTTTT', rs)
          if (rs.length > 0 && rs[0].statusBt === 'cancel') {
            console.log('RSTESTTTTTTee')
            this.checkStatusBooking = 'False'
          } else {
            this.checkStatusBooking = 'True'
          }
        })
    },
    async UploadImg () {
      this.overlay = true
      console.log('this.formUpload >>>>>.', this.DataFlowNameAll)

      if (this.formUpload.depositImge !== '') {
        this.$swal({
          title:
            this.languageSelect === 0
              ? 'ยืนยันการบันทึกข้อมูล'
              : 'Please confirm your information',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: this.languageSelect === 0 ? 'ใช่' : 'Yes',
          cancelButtonText: this.languageSelect === 0 ? 'ไม่' : 'No'
        })
          .then(async result => {
            let slipSaved = false
            try {
              if (result !== true) {
                this.overlay = false
                return
              }
              await this.checkBooking(this.formUpload.bookNo)
              if (this.checkStatusBooking === 'False') {
                await this.$swal(
                  this.languageSelect === 0 ? 'ผิดพลาด' : 'Error',
                  this.languageSelect === 0
                    ? 'เนื่องจากไม่ชำระเงินตามระยะเวลาที่กำหนด'
                    : 'Due to non-payment on time',
                  'error'
                )
                  .catch(() => {}) // ปิดโดยแตะพื้นหลังจะ reject ให้ไป reload เหมือนเดิม
                  .then(async result => {
                    this.$router.push('/PaymentUpload?shopId=' + this.shopId)
                    location.reload()
                  })
              } else if (this.checkStatusBooking === 'True') {
                if (!this.couponStatus) {
                  if (this.statusSlipOKOpen) {
                    this.resCheckSlipOK = await this.$refs.childRef.onCheckSlipForIMG(
                      this.shopId,
                      this.formUpload.depositPrice,
                      this.$route.query.languageSelect,
                      this.formUpload.bookNo
                    )
                    if (!this.resCheckSlipOK) {
                      this.formUpload.depositImge = ''
                      this.filesUpdateImgCover = null
                      this.overlay = false
                      return
                    }
                  }
                }

                if (this.filesUpdateImgCover) {
                  try {
                    let params = new FormData()
                    let configDepositUpload = { headers: { bookNo: this.formUpload.bookNo }, timeout: 60000 }
                    params.append('file', this.filesUpdateImgCover)
                    const response = await axios.post(
                      this.DNS_IP + `/file/upload/deposit`,
                      params,
                      configDepositUpload
                    )
                    if (response.data) {
                      this.formUpload.depositImge = response.data
                    } else {
                      throw new Error('Did not receive image link from server')
                    }
                  } catch (error) {
                    console.error('upload deposit error:', error)
                    this.$swal(
                      this.languageSelect === 0 ? 'อัพโหลดสลิปไม่สำเร็จ' : 'Upload slip failed',
                      getApiErrorMessage(error, this.languageSelect === 0, true),
                      'error'
                    )
                    this.overlay = false
                    return
                  }
                }

                this.formUpload.depositStatus = 'True'
                this.formUpload.paymentType = this.$route.query.coupon
                  ? 'other'
                  : 'payment'

                await axios.post(
                  this.DNS_IP + '/Booking/edit/' + this.formUpload.bookNo,
                  this.formUpload,
                  { timeout: 30000 }
                )
                slipSaved = true

                let flowItem = this.BookingData.find(item => item.bookNo === this.bookNo)
                let flowId = flowItem ? flowItem.flowId : (this.bookingDataSelect[0] ? this.bookingDataSelect[0].flowId : '')

                let checkDataFlow = []
                if (this.$route.query.flowId) {
                  checkDataFlow = this.DataFlowNameAll.filter(
                    item => item.flowId === this.bookingDataSelect[0].flowId
                  )
                } else {
                  checkDataFlow = this.DataFlowNameAll.filter(
                    item => item.flowId === flowId
                  )
                }

                await this.pushMsgLineNotifyGroup(this.formUpload.bookNo)

                if (checkDataFlow.length > 0 && (checkDataFlow[0].updateStatusConfirm === 'True' || this.resCheckSlipOK === true)) {
                  let dtt = {
                    bookNo: this.bookNo,
                    contactDate: moment().format('YYYY-MM-DD HH:mm'),
                    status: 'confirm',
                    statusUse: 'use',
                    shopId: this.shopId,
                    CREATE_USER: this.userId,
                    LAST_USER: this.userId
                  }
                  await axios.post(this.DNS_IP + '/booking_transaction/add', dtt)
                  if (this.statusGoogleCalendar === 'True') {
                    this.connectGoogleCalendar(dtt.shopId, 'Add', dtt.bookNo)
                  }
                  await this.pushMsgConfirm(this.formUpload.bookNo, flowId)
                } else {
                  await this.pushMsgCustomer(this.formUpload.bookNo, flowId)
                }
                this.overlay = false
                await this.$swal({
                  title: this.languageSelect === 0 ? 'สำเร็จ' : 'Success',
                  text:
                    this.languageSelect === 0
                      ? 'อัพโหลดสลิปสำเร็จ'
                      : 'The slip has been successfully uploaded.',
                  type: 'success',
                  timer: 1500,
                  showConfirmButton: false
                }).catch(() => {}) // ปิดด้วย timer จะ reject('timer') ไม่ใช่ error
              }
            } catch (error) {
              console.error('UploadImg process error:', error)
              this.overlay = false
              if (slipSaved) {
                // สลิปบันทึกแล้ว แต่ขั้นตอนส่งข้อความ/ยืนยันหลังจากนั้นพัง ไม่ต้องให้ลูกค้าอัพโหลดซ้ำ
                this.$swal(
                  this.languageSelect === 0 ? 'อัพโหลดสลิปสำเร็จ' : 'Slip uploaded',
                  this.languageSelect === 0
                    ? 'ระบบได้รับสลิปของท่านแล้ว แต่ส่งข้อความยืนยันไม่สำเร็จ กรุณารอเจ้าหน้าที่ตรวจสอบ ไม่ต้องอัพโหลดซ้ำ'
                    : 'Your slip has been received, but the confirmation message could not be sent. Please wait for staff to verify. No need to upload again.',
                  'warning'
                )
              } else {
                this.$swal(
                  this.languageSelect === 0 ? 'ทำรายการไม่สำเร็จ' : 'Failed',
                  getApiErrorMessage(error, this.languageSelect === 0),
                  'error'
                )
              }
            } finally {
              this.overlay = false
            }
          })
          .catch(error => {
            console.log('Cencel : ', error)
            this.overlay = false
          })
      } else {
        this.$swal(
          this.languageSelect === 0 ? 'ผิดพลาด' : 'Error',
          this.languageSelect === 0
            ? 'กรุณาอัพโหลดหลักฐานการโอนเงิน'
            : 'Please upload proof of payment.',
          'error'
        )
        this.overlay = false
        console.log('this.overlay', this.overlay)
      }
    },
    async connectGoogleCalendar (shopId, status, bookNo) {
      const payload = {
        bookNo: bookNo,
        status: status
      }
      await axios
        .post(this.DNS_IP + '/GoogleCalendarApi/event/byBookNo', payload)
        .then(response => {
          console.log('response connectGoogleCalendar : ', response)
        })
        .catch((error) => {
          console.log('error connectGoogleCalendar : ', error)
        })
      // let timeSlotStatus = this.shop[0].timeSlotStatus || 'False'
      // if (timeSlotStatus === 'True') {
      //   this.$refs.GoogleCalendarRef.checkTypeEvenEmp(shopId, status, bookNo)
      // } else {
      //   this.$refs.GoogleCalendarRef.checkTypeEven(shopId, status, bookNo)
      // }
    },
    getShop () {
      if (this.$route.query.redirectBy) {
        let check = this.$route.query.redirectBy
        if (check === 'rating') {
          this.redirectBy = check
        } else if (check === 'BookingForm') {
          this.redirectBy = check
        } else {
          this.redirectBy = 'N'
        }
        console.log('redirectBy', check)
      } else {
        this.redirectBy = null
      }
      if (this.$route.query.shopId) {
        axios
          .get(this.DNS_IP + '/sys_shop/get?shopId=' + this.$route.query.shopId)
          .then(response => {
            let rs = response.data
            if (rs.length > 0) {
              this.shop = rs
              rs.forEach(v => {
                if (v.primaryColor) {
                  this.ColorByShop.push(v.primaryColor, v.secondaryColor)
                  this.DarkModeBackground = v.primaryColor
                  this.DarkModeButton = v.secondaryColor
                } else {
                  this.ColorByShop.push('#E1F3FF', '#FFFFFF')
                  this.DarkModeBackground = '#FFFFFF'
                  this.DarkModeButton = '#E1F3FF'
                }
                if (v.shopImge) {
                  this.LoGo = v.shopImge
                } else {
                  this.LoGo = require('@/assets/Thank.svg')
                }
                if (v.shopImageCover) {
                  this.ImgCover = v.shopImageCover
                } else {
                  if (v.category === 'ธุรกิจรถยนต์') {
                    this.ImgCover = require('@/assets/Cover2.jpg')
                  } else {
                    this.ImgCover = require('@/assets/Cover2.jpg')
                  }
                }
                if (v.darkMode === 'True') {
                  this.DarkMode = '#FFFFFF'
                  this.DarkModefont = '#FFFFFF'
                } else {
                  this.DarkMode = ''
                  this.DarkModefont = '#173053'
                }
              })
              this.bookingthankText = rs[0].bookingthankText
              console.log('this.bookingthankText', this.bookingthankText)
              this.statusGoogleCalendar = rs[0].statusGoogleCalendar
              this.statusGoogleCalendarEmp = rs[0].statusGoogleCalendarEmp
            } else {
              this.shop = null
            }
          })
      } else {
        this.ColorByShop.push('#E1F3FF', '#FFFFFF')
        this.LoGo = require('@/assets/Thank.svg')
        this.DarkMode = ''
        this.DarkModefont = '#173053'
      }
    },
    async getbookingData () {
      this.BookingData = []
      if (this.bookNo !== '') {
        axios
          .get(this.DNS_IP + '/BookingData/get?bookNo=' + this.bookNo)
          .then(response => {
            let rs = response.data
            console.log('rs1', rs)
            console.log('this.bookNo', this.bookNo)
            if (rs.length > 0) {
              // for (let i = 0; i < rs.length; i++) {
              //   let d = rs[i]
              //   if (this.languageSelect === 0) {
              //     d.fieldName = d.fieldName
              //   } else {
              //     d.fieldName = d.fieldNameEn
              //   }
              // }
              this.BookingData = rs
            }
          })
          .catch(function (error) {
            console.log('Error getting profile: ' + error)
          })
      }
    },
    async getbooking () {
      if (this.bookNo !== '') {
        axios
          .get(this.DNS_IP + '/Booking/get?bookNo=' + this.bookNo)
          .then(response => {
            let rs = response.data
            console.log('getbooking ', rs)
            if (rs.length > 0) {
              this.formUpload.bookNo = rs[0].bookNo
              this.formUpload.depositImge = rs[0].depositImge || ''
              this.formUpload.depositStatus = rs[0].depositImge || 'False'
              this.userId = rs[0].userId
              this.languageSelect = rs[0].bookingLanguage
              this.bookingDataSelect = rs
            }
          })
          .catch(function (error) {
            console.log('Error getting profile: ' + error)
          })
      }
    },
    async getBookingView () {
      this.SelectBookingData = []
      await axios
        .get(
          this.DNS_IP +
            '/booking_view/get?shopId=' +
            this.shopId +
            '&userId=' +
            this.profile.userId +
            '&depositStatus=null&checkDeposit=True'
        )
        .then(response => {
          let rs = response.data
          console.log('rsๅ', rs)
          if (rs.length > 0) {
            // console.log('test11')
            rs.forEach((v, k) => {
              // console.log('test13', moment(v.dueDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD'))
              // if (moment(v.dueDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')) {
              // console.log('test122', v)
              if (v.statusBt !== 'cancel') {
                if (
                  moment(v.dueDate).format('YYYY-MM-DD') >=
                  moment().format('YYYY-MM-DD')
                ) {
                  if (v.depositStatus === 'False' || v.depositStatus === null) {
                    // console.log('test1')
                    let s = {}
                    if (this.languageSelect === 0) {
                      v.flowName = v.flowName
                    } else {
                      v.flowName = v.flowNameEn
                    }
                    s.text = `${v.flowName}
                  ${v.dueDate}`
                    s.value = v.bookNo
                    this.SelectBookingData.push(s)
                  } else {
                    // console.log('test12')
                    this.SelectBookingData = []
                  }
                }
              }
              if (this.SelectBookingData.length === 1) {
                // console.log('test14')
                this.bookNo = this.SelectBookingData[0].value
                this.getbookingData()
                this.getbooking()
              }
              // }
            })
          }
          console.log('this.SelectBookingData', this.SelectBookingData)
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    async pushMsgCustomer (bookNo, flowId) {
      let UserId = ''
      if (this.profile === null) {
        UserId = this.userId
      } else {
        UserId = this.profile.userId
      }
      const result = await axios.get(
        this.DNS_IP +
          '/member/get?shopId=' +
          this.shopId +
          '&liffUserId=' +
          UserId
      )
      console.log('result', result.data.status)
      if (result.data.status === false) {
        let statusSend = {
          statusSend: 'false'
        }
        await axios.post(this.DNS_IP + '/Booking/edit/' + bookNo, statusSend)
        console.log('statusSend', 'false')
        if (this.$liff.isInClient()) {
          // if (this.profile.userId === 'U29e920c9ca4411b09b8c1704f37197c3' || this.profile.userId === 'U35b246f2825895f3fdcc09b72d589f92') {
          //   alert('isInClient')
          // }
          this.$liff
            .sendMessages([
              {
                type: 'text',
                text: 'เปิดรับการแจ้งเตือน'
              }
            ])
            .then(() => {
              console.log('message sent')
              // alert('message sent')
              // this.$liff.closeWindow()
            })
            .catch(err => {
              console.log('error', err)
              // alert('error:' + err)
            })
        }
        await this.getCondition(flowId, 'Thank', bookNo)
      } else {
        let statusSend = {
          statusSend: 'true'
        }
        await axios.post(this.DNS_IP + '/Booking/edit/' + bookNo, statusSend)
        // let lineUserId = result.data[0].lineUserId
        console.log('statusSend', 'true')
        let updateStatusSend = {
          updateStatusSend: 'false'
        }
        axios
          .post(
            this.DNS_IP + '/Booking/pushMsgCustomer/' + bookNo,
            updateStatusSend
          )
          .then(async response => {
            await this.getCondition(flowId, 'Thank', bookNo)
          })
      }
      // this.clearData()
    },
    async pushMsgConfirm (bookNo, flowId) {
      await axios
        .post(this.DNS_IP + '/Booking/pushMsgConfirm/' + bookNo)
        .then(async response => {
          await this.getCondition(flowId, 'Thank', bookNo)
        })
        .catch(error => {
          console.log('error function pushMsgQueue : ', error)
        })
    },
    async pushMsgLineNotifyGroup (bookNo) {
      console.log('bookNo')

      await axios
        .post(this.DNS_IP + '/Booking/pushMsgLineNotifyGroupBefamily/' + bookNo, null, { timeout: 20000 })
        .then(response => {})
        .catch(error => {
          console.log('error function pushMsgLineNotifyGroup : ', error)
        })
    },
    async sendEmailConfirm (bookNo) {
      let obj = {
        bookNo: bookNo
      }
      await axios
        .post(this.DNS_IP + '/email_booking/confirm_noLine', obj)
        .then(response => {})
        .catch(error => {
          console.log(error)
        })
    },
    async getCondition (flowId, text, bookNo) {
      console.log('test', text)
      await axios
        .get(
          this.DNS_IP + '/flow/get?flowId=' + flowId + '&shopId=' + this.shopId
        )
        .then(response => {
          let rs = response.data
          if (rs.status === false) {
            if (text === 'BookingQrcode') {
              this.$router.push(
                '/BookingQrcode?bookNo=' + bookNo + '&shopId=' + this.shopId
              )
            } else {
              this.$router.push(
                '/Thank?shopId=' +
                  this.shopId +
                  '&redirectBy=PaymentUpload&flowId=' +
                  flowId +
                  '&bookNo=' +
                  bookNo +
                  '&languageSelect=' +
                  this.languageSelect
              )
            }
          } else {
            if (rs[0].showCondition === 'แสดง') {
              this.$router.push(
                '/ConditionFlow?shopId=' + this.shopId + '&flowId=' + flowId
              )
            } else {
              if (text === 'BookingQrcode') {
                this.$router.push(
                  '/BookingQrcode?bookNo=' + bookNo + '&shopId=' + this.shopId
                )
              } else {
                this.$router.push(
                  '/Thank?shopId=' +
                    this.shopId +
                    '&redirectBy=PaymentUpload&flowId=' +
                    flowId +
                    '&bookNo=' +
                    bookNo +
                    '&languageSelect=' +
                    this.languageSelect
                )
              }
            }
          }
        })
    },
    async getDetails () {
      await axios
        .post(this.DNS_IP + '/Booking/setDetailsCopyLinkAddData/' + this.bookNo)
        .then(response => {
          let rs = response.data
          console.log('rs getDetails empWaiting', rs)
          this.joyRideInsuranceDetails =
            rs.empWaitingDetails.joyRideInsuranceDetails
          this.joyRideReserveNowDetails =
            rs.empWaitingDetails.joyRideReserveNowDetails
          console.log(
            'rs.empWaitingDetails.menuItem',
            rs.empWaitingDetails.menuItem
          )
          const menuItems = {
            'ผู้ดูแล 4 ชั่วโมง': 'Assistant 4 hours',
            'ผู้ดูแล 5 ชั่วโมง': 'Assistant 5 hours',
            'ผู้ดูแล 6 ชั่วโมง': 'Assistant 6 hours',
            'ผู้ดูแล เหมา 10 ชั่วโมง': 'Assistant 10 hours (flat rate)'
          }
          if (rs.empWaitingDetails.menuItem) {
            if (this.languageSelect === 0) {
              this.menuItem = JSON.parse(rs.empWaitingDetails.menuItem)[0].name
            } else {
              this.menuItemEn =
                menuItems[JSON.parse(rs.empWaitingDetails.menuItem)[0].name]
            }
          } else {
            this.menuItem = ''
          }
          const textMsgEn = rs.messageEn.split('\n')
          console.log('textMsgEn', textMsgEn)
          this.joyRideInsuranceDetailsEn = textMsgEn
            .find(line => line.includes('Urgent booking'))
            .replace('✅ ', '')
          this.joyRideReserveNowDetailsEn = textMsgEn
            .find(line => line.includes('Buy additional'))
            .replace('✅ ', '')
          console.log(
            'joyRideInsuranceDetailsEn',
            this.joyRideInsuranceDetailsEn
          )
          console.log(
            'joyRideReserveNowDetailsEn',
            this.joyRideReserveNowDetailsEn
          )
        })
    }
  }
}
</script>

<style scoped>
.button {
  width: 45%;
  color: #fff;
  font-weight: 200;
  letter-spacing: 1px;
  margin: 6px 3px;
  padding: 10px 28px;
  border-radius: 25px !important;
  background-color: #0047a5;
}
.main {
  background-color: #ffffff;
  height: 100vh;
}
.content {
  overflow: auto;
  white-space: normal;
}
.a {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/PaymentUpload.vue